import React from "react";

interface SkillTagProps {
  name: string;
  level: "expert" | "advanced" | "intermediate";
}

const levelBorderHover: Record<string, string> = {
  expert: "hover:border-accent hover:text-accent",
  advanced: "hover:border-brand hover:text-brand",
  intermediate: "hover:border-warm hover:text-warm",
};

const dotColor: Record<string, string> = {
  expert: "bg-accent",
  advanced: "bg-brand",
  intermediate: "bg-warm",
};

function SkillTag({ name, level }: SkillTagProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded text-xs font-medium font-mono
        bg-bg-raised text-content-secondary border border-border-subtle
        transition-all duration-150 cursor-default ${levelBorderHover[level]}`}
    >
      <span className={`w-1 h-1 rounded-full ${dotColor[level]}`} />
      {name}
    </span>
  );
}

export default SkillTag;